import { ACCOUNT_PROVIDER, TypeIdSchema } from '@unipile/db';
import { Type } from '@sinclair/typebox';
import { StringEnum } from '../../utils/typebox';
import { PUBLIC_ACCOUNT_STATUS } from './account.schema';

export const RemoveAccountParamsSchema = Type.Object({
  account_id: TypeIdSchema('account', { description: 'The ID of the Account to remove.' }),
});

export const ListAccountsQuerySchema = Type.Object({
  account_scope_id: Type.Optional(
    Type.Union([TypeIdSchema('accountScope'), Type.Literal('none')], {
      description: 'Filter Accounts by Scope ID, or use `none` to return Accounts without a Scope.',
    }),
  ),
  status: Type.Optional(
    StringEnum([...PUBLIC_ACCOUNT_STATUS], { description: 'Filter to return only accounts of the given status.' }),
  ),
  provider: Type.Optional(
    StringEnum([...ACCOUNT_PROVIDER], {
      description: `Filter to return only accounts of the given provider.
        - \`mock\` is mock.
        - \`whatsapp\` is WhatsApp.
        - \`linkedin\` is LinkedIn.
        - \`instagram\` is Instagram.
        - \`facebook\` is Facebook.
        - \`google\` is Google.
        - \`outlook\` is Outlook.
        - \`telegram\` is Telegram.
        - \`imap\` is IMAP.`,
    }),
  ),
  search: Type.Optional(
    Type.String({ description: 'Filter to return only accounts matching the given search term on `name` or `id`.' }),
  ),
  offset: Type.Optional(Type.String({ description: 'A non-negative integer offset used for pagination.', pattern: '^[0-9]+$' })),
  limit: Type.Optional(
    Type.String({ description: 'A positive integer limit of items to be returned.', default: '20', pattern: '^[0-9]+$' }),
  ),
});
